import { useState, useEffect } from 'react';

import WorkingAreasService from "../services/WorkingAreasService";
import LogUtils from "../utils/LogUtils";

const TAG = "useWorkingAreasService";
const logUtils = new LogUtils();

export function useGetWorkingAreasSelector({cityId, agentId}) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [workingAreas, setWorkingAreas] = useState([]);
  const [agentWorkingArea, setAgentWorkingArea] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setWorkingAreas([]);
    };
  }, []);

  useEffect(() => {
    const workingAreasService = new WorkingAreasService();

    async function getWorkingAreas() {
      try {
        if (!isMounted || !cityId || !agentId) return false;

        setIsLoading(true);
        const response = await workingAreasService.getWorkingAreas({cityId});
        setIsLoading(false);

        if (!isMounted || !response?.data) return false;

        setUpWorkingAreas(response.data, agentId);

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getWorkingAreas", err);
        setIsLoading(false);
      }
    }

    function setUpWorkingAreas(workingAreas, agentId) {
      setAgentWorkingArea(
        workingAreas.find(
          workingArea => workingArea?.agent_user_id && workingArea?.agent_user_id === agentId
        )
      );
      setWorkingAreas(workingAreas);
    }

    getWorkingAreas();

    return () => {
      setWorkingAreas([]);
    };
  }, [isMounted, cityId, agentId]);

  return [isLoading, workingAreas, agentWorkingArea];
}

export function useGetWorkingArea({workingAreaId}) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [workingArea, setWorkingArea] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setWorkingArea(null);
    };
  }, []);

  useEffect(() => {
    async function getWorkingArea() {
      try {
        if (!isMounted || !workingAreaId) return false;

        setIsLoading(true);
        const workingAreasService = new WorkingAreasService();
        const response = await workingAreasService.getWorkingArea({workingAreaId});
        setIsLoading(false);

        if (!isMounted || !response?.data) return false;

        setWorkingArea(response.data);

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getWorkingArea", err);
        setIsLoading(false);
      }
    }

    getWorkingArea();

    return () => {
      setWorkingArea(null);
    };
  }, [isMounted, workingAreaId]);

  return [isLoading, workingArea];
}
